import { retry } from './retry';
import { LiveblogTenant } from '../typings/liveblog-themes';

const INTCMP_STORAGE_KEY = 'intcmp';
const INTCMP_PREFIX = Object.freeze({
  tg24: 'skytg24',
  sport: 'skysport',
});

declare global {
  interface Window {
    __satelliteLoaded: any;
    _satellite: any;
  }
}

/**
 * Converts a key/value object in a data-key=value object
 * @param dataObject object containing key/value pairs
 */
export const objectToDataAttributes = (dataObject: object): object => {
  const keyValues = Object.keys(dataObject).map((key) => {
    const newKey = `data-${key.toLowerCase()}`;
    return { [newKey]: (dataObject as any)[key] };
  });
  return Object.assign({}, ...keyValues);
};

export const generateIntCmpFromTenant = (tenant: LiveblogTenant, intCmpSuffix: string): string =>
  `${INTCMP_PREFIX[tenant]}_${intCmpSuffix}`;

export const setDataLayerElement = (intcmp?: string) => {
  if (intcmp) {
    localStorage.setItem(INTCMP_STORAGE_KEY, intcmp);
  }
};

export const initDatalayerElement = ($element: any) => {
  Array.from($element.querySelectorAll('[data-intcmp]')).forEach((ln: any) => {
    ln.addEventListener('click', () => {
      localStorage.setItem(INTCMP_STORAGE_KEY, ln.dataset.intcmp);
    });
  });

  Array.from($element.querySelectorAll('[data-intcmp-qp]')).forEach((ln: any) => {
    const url = new URL(ln.href);
    url.searchParams.set(INTCMP_STORAGE_KEY, ln.dataset.intcmpQp);

    ln.addEventListener('click', () => {
      ln.href = url;
    });
  });
};

export const track = (param1: string, param2: any) => {
  const params = [param1];
  if (param2) {
    params.push(param2);
  }
  retry({
    maxAttempts: 5,
    checkEvery: 3000,
    checkFunction: () => Boolean(window.__satelliteLoaded),
  })
    .then(() => {
      window._satellite.track(...params);
      console.info('[ Tracking ] Satellite is tracking - param1 & param2: ', param1, param2);
    })
    .catch(() =>
      console.error('[ Tracking ] Satellite is not available, unable to track - param1 & param2', param1, param2)
    );
};
